import * as React from "react";
import { useEffect } from 'react';
import {
  Row,
  Col,
  Space,
  Typography,
  Form,
  Select,
  Divider,
  Button,
  Dropdown,
  Input,
} from "antd";
import {
  PlusOutlined,
  FilterOutlined,
  SearchOutlined,
  DownloadOutlined,
  ExportOutlined
} from "@ant-design/icons";
const { Title, Text } = Typography;
import grid from '../SectionHeader/grid.svg';
import list from '../SectionHeader/list.svg';
import Search from "antd/es/input/Search";
import { DateField, ReactSelectField } from "../../atoms/FormElement";
import { Controller, useForm } from "react-hook-form";


export default (props) => {
  const {
    heading,
    total,
    importAction,
    filterAction,
    addNewAction,
    dropNewAction,
    dropItems,
    dropTrigger,
    addMoreButton,
    exportAction,
    handleShow,
    showOption,
    handleView,
    viewOption,
    viewOptionLabel,
    viewOptionIcon,
    viewOptionAction,
    search,
    searchOptions,
    searchName,
    searchLabel,
    defaultSearch,
    headReverse,
    viewRSelectOption,
    initialValue,
    onChange,
    justifiedItems,
    justifyEnd,
    justifyStart,
    dateAction,
    initialDate,
    headTopLeftText,
    searchBy,
    updateValue
  } = props;

  const {
    control,
    formState: { errors },
    setValue
  } = useForm();

  // useEffect(() => {
  //   // const views = document.querySelector('#display-views') as HTMLInputElement;
  //   // const gridselect = document.querySelector('.grid');
  //   // // const listselect = document.querySelector('.list');
  //   // const grid = document.querySelector('.prop-card-grid');
  //   // listselect.addEventListener('click', () => {
  //   //   grid.classList.add('prop-list-grid')
  //   //   gridselect.classList.remove('grid-selected')
  //   //   listselect.classList.add('grid-selected')

  //   // })
  //   // gridselect.addEventListener('click', () => {
  //   //   grid.classList.remove('prop-list-grid')
  //   //   gridselect.classList.add('grid-selected')
  //   //   // listselect.classList.remove('grid-selected')
  //   // })

  //   // if(views.value == "list"){
  //   //     grid.classList.toggle('prop-list-grid');
  //   // }
  // })

  useEffect(() => {
    if (updateValue?.length > 0) {
      updateValue?.map(e => {
        e?.label && setValue(e?.label, e?.value);
      });
    } else if (updateValue?.label)
      setValue(updateValue?.label, updateValue?.value);
  }, [updateValue]);


  const searchDropdown = searchOptions?.length > 0 ? (<Select defaultValue={searchOptions.find(e => e.default == true)?.value ?? searchOptions[0]?.value}
    labelInValue
    placeholder={`Select ${searchName ? searchName : ''}`}
    style={{ maxWidth: "150px" }}
    onChange={(e) => searchBy(e)}
    size="large"
    dropdownMatchSelectWidth={false}
    options={searchOptions} />
  ) : false;

  return (
    <Row gutter={[24, 24]} className="bc">
      <Col flex="auto">
        <Space size={8} className="h-100">
          {/* {headingOptions.length > 1 ?
            <Select
            bordered={false}
            labelInValue
            onChange={headingAction}
            size="large"
            >
              <Select.Option value="all">All Request</Select.Option>
              <Select.Option value="selected">Selected</Select.Option>
            </Select>
            :
          <Title level={2} className="custom-title32">{headingOptions[0]}</Title>
          } */}
          <Title
            level={2}
            className={`custom-title32 ${total ? "borderRight" : ""}`}
          >
            {heading}
          </Title>
          {/* #removed */}
          {total && (
            <Title level={5} className="mb-0 total-title">
              {total} Total
            </Title>
          )}

          {headTopLeftText && (
            <Title level={5} className={`mb-0 total-title ${headTopLeftText ? "borderRight" : ""}`}>
              {headTopLeftText}
            </Title>
          )}

        </Space>
      </Col>
      {importAction && (
        <Col>
          <Button
            size="large"
            icon={<DownloadOutlined />}
            onClick={importAction}
          >
            Import
          </Button>
        </Col>
      )}
      {filterAction && (
        <Col>
          <Button size="large" icon={<FilterOutlined />} onClick={filterAction}>
            Filters
          </Button>
        </Col>
      )}
      {addNewAction && (
        <Col>
          <Button size="large" type="primary" className={`property_card_btn ${props?.isDisabled ? "disabled" : ""}`} onClick={addNewAction} disabled={props?.isDisabled} >
            Add New {props.addText && props.addText} <PlusOutlined />
          </Button>
        </Col>
      )}
      {dropNewAction && (
        <Col>
          <Dropdown menu={{ items: dropItems, onClick: dropNewAction }} trigger={dropTrigger}>
            <Button size="large" type="primary" className="property_card_btn" onClick={(e) => e.preventDefault()}>
              Add New {props.addText && props.addText} <PlusOutlined />
            </Button>
          </Dropdown>

        </Col>
      )}
      {addMoreButton && (
        <Col>
          <Button size="large" type="primary" className="property_card_btn" disabled={props?.isDisabled} onClick={addMoreButton}>
            {props.addMoreText && props.addMoreText} <PlusOutlined />
          </Button>
        </Col>
      )}
      {exportAction && (
        <Col>
          <Button size="large" icon={<ExportOutlined />} onClick={addMoreButton}>
            Export
          </Button>
        </Col>
      )}

      <Col span={24} style={(search || viewOption || viewRSelectOption || dateAction) && {height:"80px"}}>

        <Form className="ag-filter-bar org_form" style={headReverse ? {flexDirection: 'row-reverse', justifyContent: 'start'} : { alignItems: "start", }} name="property_filter" layout="vertical">
          {/* #removed show all properties */}
          {/* {showOption && showOption.length && (
            <Form.Item name="show" label="Show" initialValue={{ value: "All" }}>
              <Select
                bordered={false}
                labelInValue
                onChange={handleShow}
                size="large"
                options={showOption}
              />
            </Form.Item>
          )} */}

          {search && (
            <Col xs={24} lg={10} xl={10} style={headReverse ? {} : { float: 'left' }}>
              <Form.Item className="search" label={searchDropdown ? "Search by:" : " "}>
                {/* <Input.Group compact>
                  <Input className="org_search"
                    bordered={false}
                    placeholder="Search"
                    // prefix={<SearchOutlined />}
                    size="large"
                    style={{ width: 'calc(100% - 40px)' }}
                    onChange={search ?? (() => void 0)}
                  />
                  <Button type="primary" size="large" icon={<SearchOutlined />} onClick={searchOnClick ?? (() => void 0)}>
                  </Button>
                </Input.Group> */}
                <Search
                  addonBefore={searchDropdown}
                  className="org_search"
                  style={{...(viewRSelectOption ? {marginTop: 7} : {})}}
                  placeholder={searchLabel ?? "Search..."} // 
                  enterButton
                  defaultValue={defaultSearch ?? ""}
                  bordered={false}
                  size="large"
                  allowClear
                  onSearch={search}
                />
              </Form.Item>
            </Col>
          )}
          {viewOption && viewOption.length && (
            <Col xs={24} lg={14} xl={14} className={justifiedItems ? "org_form" : "wrapped-items"}
              style={justifyEnd ? { justifyContent: "end" } : justifyStart ? { justifyContent: "start" } : {}}>

              {viewOptionLabel && (
                <div className="viewOptiontitle">
                  <i>{viewOptionIcon ?? ""} {viewOptionLabel ?? ""}</i>
                </div>
              )}

              {viewOption.map((item) => (
                <Controller
                  name={item?.name}
                  control={control}
                  defaultValue={item?.initialValue}
                  render={({ field: { onChange, value, ref } }) => (
                    <Form.Item
                      style={justifyEnd ? { marginLeft: "9px" } : {}}
                      // name={item?.name}
                      label={`${item?.label} (${item?.options?.length > 0 ? item?.options?.length : 0})`}
                      initialValue={item?.initialValue}
                    >
                      <Select
                        // bordered={false}
                        // allowClear={true}
                        value={props.disabled ? '' : value}
                        ref={ref}
                        onChange={(e) => {
                          onChange(e);
                          handleView(e, item?.name ?? "");
                        }}
                        showSearch={item?.search === true ? true : false}
                        filterOption={(input, option) =>
                          (option?.label ?? '').toString().toLowerCase().includes(input.toLowerCase())
                        }
                        labelInValue
                        placeholder={`Select ${item?.name}`}
                        // onChange={(e) => handleView(e, item?.name ?? "")}
                        size="large"
                        options={item?.options}
                      />
                    </Form.Item>
                  )}
                />
              ))}
              {viewOptionAction &&
                (<Button size="large" type="primary" style={{ marginLeft: "9px", padding: "5px 14px !important" }} className="property_card_btn" onClick={viewOptionAction}>
                  {/* Create New  */}
                  <PlusOutlined />
                </Button>)}
            </Col>
          )}
          {viewRSelectOption && viewRSelectOption.length && (
            <Col xs={24} lg={14} xl={8} className={justifiedItems ? "org_form" : "wrapped-items"}
              style={justifyEnd ? { justifyContent: "end" } : justifyStart ? { justifyContent: "start" } : {}}>

              {viewRSelectOption.map((item) => (
                <div style={{marginRight: 5}}>
                  <ReactSelectField
                    isRequired={false}
                    style={{borderRadius: 8, borderColor: '#ffffff', minHeight: 40, minWidth: 200}}
                    fieldname={item?.name}
                    label={item?.name}
                    control={control}
                    iProps={{ placeholder: item.placeholder }}
                    nav={true}
                    onChange={onChange}
                    initialValue={initialValue}
                    selectOption={
                      item?.options?.length > 0 &&
                      item?.options
                    }
                  />
                </div>
              ))}
            </Col>
          )}
          {dateAction && (
            <Col xs={24} lg={16} xl={16} className={justifiedItems ? "org_form" : "wrapped-items"}>

              <div style={{ paddingLeft: "14px" }}>Select Date: </div>

              <Form.Item
                name="Date"
                label="Renewal Date"
                initialValue=""
              >
                <DateField
                  fieldname="dateSearch"
                  control={control}
                  onChange={(e) => dateAction(e)}
                  initValue={initialDate ?? ""}
                  iProps={{
                    placeholder: "DD-MM-YYYY",
                    format: "DD-MM-YYYY",
                    // disabledDate: disableCommenceDate,
                    // disabled: disableAll,
                  }}
                />
              </Form.Item>
            </Col>
          )}
          <Col span={3} className="viewby">
            {/* <div id="display-views">
              <p>View By</p>
              <div className="grid grid-selected"><img src={grid} /></div>
              <div className="list"><img src={list} /></div>
            </div> */}
          </Col>
        </Form>
      </Col>
      {!props.noborder && <Divider className="mt-0 ag-border-cold9" />}
    </Row>
  );
};